module.exports = __webpack_public_path__ + "img/t_h2.ed973082.png";